import React, { useState } from 'react';
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { gridComponents } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import moment from "moment";
import { ReactComponent as EyeIcon } from "assets/img/svg/eyeIcon.svg";
import NoRowOverlay from "views/pages/manage/masters/holidayMaster/NoRowOverlay";
import ALoader from 'views/pages/manage/common/a-loader';
import { Dialog, Tooltip } from '@mui/material';
import styles from "./advancePaymentDetails/paymentDialog/jodoListing/style.module.scss";
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import { formattedPrice } from './advancePaymentDetails/paymentDialog/constant';


const ViewReaceiptDialoge = ({ rows, handleClose, isOpen, loader, currentApplicationDetails }) => {
    const getAmountWithStyling = (params) => {
        const amount = formattedPrice(params.value, true);
        const isLessThanZero = Number(params.value) < 0;

        return (
            <span
                style={{
                    color: isLessThanZero ? "#DC2804" : "#05945B",
                    fontFamily: "Gilroy-Medium",
                    fontWeight: "700",
                }}
            >
                {amount}
            </span>
        );
    }
    const columns = [
        new AGridColDef("acknowledgementId", "Acknowledgement ID", false)
            .setMinWidth(100)
            .editable(true)
            .setFlex(0.90)
            .renderCellComponent((params) => (
                params?.value ? <Tooltip title={params?.value}>
                    <div className={`ellipsis-text-container`}>{params?.value}</div>
                </Tooltip> : <div>-</div>
            )),
        new AGridColDef("receiptNumber", "Receipt No", false)
            .setMinWidth(90)
            .editable(true)
            .setFlex(0.80)
            .renderCellComponent((params) => (
                params?.value ? <Tooltip title={params?.value}>
                    <div className={`ellipsis-text-container`}>{params?.value}</div>
                </Tooltip> : <div>-</div>
            )),
        new AGridColDef("totalAmount", "Receipt Amount", false)
            .setMinWidth(80)
            .editable(true)
            .setFlex(0.75)
            .renderCellComponent((params) => (
                params?.value != null ? (
                    <Tooltip title={params?.value}>
                        <div className="ellipsis-text-container">
                            {getAmountWithStyling(params)}
                        </div>
                    </Tooltip>
                ) : (
                    <div>-</div>
                )

            )),
new AGridColDef("paymodeList", "Payment mode", false)
    .setMinWidth(80)
    .editable(true)
    .setFlex(0.75)
    .renderCellComponent((params) => (
        params?.value ? <Tooltip title={params?.value}>
            <div className={`ellipsis-text-container`}>{(params?.value).join(", ")}</div>
        </Tooltip> : <div>-</div>
    )),
    new AGridColDef("createdOn", "Created on", false)
        .setMinWidth(100)
        .editable(true)
        .setFlex(1)
        .renderCellComponent((params) => (
            params?.value ? <Tooltip title={`${moment(params?.value).format('DD MMM YYYY')}, ${moment(params?.value).format('hh:mm A')}`}>
                <div className={`ellipsis-text-container`}>{

                    `${moment(params?.value).format('DD MMM YYYY')}, ${moment(params?.value).format('hh:mm A')}`
                }
                </div>
            </Tooltip> : <div>-</div>
        )),
    new AGridColDef("action", "Action", false)
        .setMinWidth(60)
        .editable(true)
        .setFlex(0.5)
        .columnAlign('right')
        .renderCellComponent((params) => {
            const {
                acknowledgementId,
                receiptNumber,
            } = params.row;
            const { applicationId,
                businessAreaDispValue,
                psid } = currentApplicationDetails
            return (<EyeIcon className='cursor' onClick={() => {
                const url = `${window.location.origin
                    }/#/admin/paymentCollection/viewReceipt/${psid}?acknowledgementId=${acknowledgementId === "N/A" ? "" : acknowledgementId
                    }&businessArea=${encodeURIComponent(
                        businessAreaDispValue
                    )}&applicationId=${encodeURIComponent(
                        applicationId
                    )}&receiptId=${encodeURIComponent(receiptNumber)}
                   &opportunityOwnerId=${encodeURIComponent(false)}
                  `;

                // Open the new tab with the constructed URL
                window.open(url, "_blank").focus();
            }} />)
        }),
    ]

return (
    <Dialog
        open={isOpen}
        PaperProps={{
            sx: {
                minWidth: "unset",
                maxWidth: "unset",
                borderRadius: "12px",
            },
        }}
    >
        <div
            className={
                `${styles["select-concession-popup"]}`
            }
        >
            <div className="d-flex justify-content-between">
                <h2 className="heading-1 text-bold">Receipt</h2>
                <AButton variant="danger_filled" onClick={handleClose} size="xs">
                    Close
                </AButton>
            </div>
            <div className="" style={{ border: '1px solid #EEE', borderRadius: '8px' }}>
                {loader && <ALoader position="fixed" />}
                <ADataGrid
                    removeWrapperContainer
                    rowModesModel
                    rows={rows || []}
                    columns={columns}
                    rowId={(row) => JSON.stringify(row)}
                    rowHeight={50}
                    serverPagination={false}
                    loading={false}
                    components={{
                        ...gridComponents,
                        NoRowsOverlay: () => (
                            <NoRowOverlay message={loader ? "Loading..." : null} />
                        ),
                    }}
                    sx={{
                        ...gridStyles,
                    }}
                    autoHeight
                    hidePagination={true}
                />

            </div>
        </div>

    </Dialog>
)
}
export default ViewReaceiptDialoge